import Modal from "~/common/components/Modal";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import { Alert } from "~/common/m3/Alert/Alert";

export const QuoteIsBundleInfoModal = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();

  const okLabel = t("generic.ok");

  const footer = (
    <Button onClick={onClose} data-test-id={"confirmation-modal-ok"}>
      {okLabel}
    </Button>
  );

  return (
    <Modal onClose={onClose} footerChildren={footer}>
      <Alert severity={"info"} className={"mb-30"}>
        {t("page.quoteDetails.message.bundle")}
      </Alert>
    </Modal>
  );
};
